import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter); // 关键：一定要先 use

const routes = [
  {
    path: "/",
    component: () => import("@/views/Layout.vue"),
    children: [
      {
        path: "", // 空字符串表示默认子路由
        name: "home",
        component: () => import("@/views/home.vue"),
        // meta: {
        //   title: '在线图片视频Ai换脸换发型工具_一键智能换装体验_Ai换脸大师',
        //   keywords: '换脸,Ai换脸,图片换脸,照片换脸,视频换脸,Ai换发型,Ai试衣,Ai换衣服,Ai换装,Ai换脸大师',
        //   description: '全球领先的AI换脸换装平台！支持图片视频实时换发型、换服装，采用2025年最新深度学习算法，10秒生成你的专属虚拟形象，免费试用无水印，请记住Ai换脸大师'
        // }
      },
      {
        path: "create", // 空字符串表示默认子路由
        name: "create",
        component: () => import("@/views/create.vue"),
        // meta: {
        //   title: '在线图片视频Ai换脸换发型工具_一键智能换装体验_Ai换脸大师',
        //   keywords: '换脸,Ai换脸,图片换脸,照片换脸,视频换脸,Ai换发型,Ai试衣,Ai换衣服,Ai换装,Ai换脸大师',
        //   description: '全球领先的AI换脸换装平台！支持图片视频实时换发型、换服装，采用2025年最新深度学习算法，10秒生成你的专属虚拟形象，免费试用无水印，请记住Ai换脸大师'
        // }
      },
      {
        // 文本生图
        path: "textCreate",
        name: "textCreate",
        component: () => import("@/views/textCreate.vue"),
      },
      {
        // Sora2.0生图
        path: "sora2Create",
        name: "sora2Create",
        component: () => import("@/views/sora2.vue"),
      },
      {
        // Seedance2.0
        path: "seedanceCreate",
        name: "seedanceCreate",
        component: () => import("@/views/seedanceCreate.vue"),
      },
      {
        // HappyHorse1.0
        path: "happyhorseCreate",
        name: "happyhorseCreate",
        component: () => import("@/views/happyhorseCreate.vue"),
      },
      // { // 工具箱
      //   path: 'toolPage/:id',
      //   name: 'toolPage',
      //   component: () => import('@/views/toolPage.vue'),
      // },
      {
        // 工具箱
        path: "toolPage/:id/",
        name: "toolPage",
        component: () => import("@/views/toolPage.vue"),
      },
      {
        // 应用场景
        path: "casePage",
        name: "casePage",
        component: () => import("@/views/casePage.vue"),
      },
      {
        path: "/tuiguang", // 推广
        name: "index_ad", // 推广
        alias: "/tuiguang/", // 兼容带斜杠的访问
        component: () => import("@/views/home.vue"),
      },
      {
        path: "/zz360tg", // 推广
        name: "zz360tg", // 推广
        alias: "/zz360tg/", // 兼容带斜杠的访问
        component: () => import("@/views/home.vue"),
      },
      {
        path: "/tg:tg", // 推广
        name: "tg", // 推广
        alias: "/tg:tg/", // 兼容带斜杠的访问
        component: () => import("@/views/home.vue"),
      },
      {
        path: "/bytuiguang", // 推广
        name: "index_byad", // 推广
        alias: "/bytuiguang/", // 兼容带斜杠的访问
        component: () => import("@/views/biyingHome.vue"),
      },
    ],
  },

  {
    // 退款
    path: "/reqrefund",
    name: "reqrefund",
    component: () => import("@/views/Reqrefund.vue"),
  },
];

const router = new VueRouter({
  mode: "history", // 或 'hash'
  routes,
});

// 先把原始方法存起来
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写 push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  // 关键：catch 住重复跳转的错误
  return originalPush.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      // 如果是“NavigationDuplicated”就吞掉，其它错误继续抛
      return err;
    }
    return Promise.reject(err);
  });
};

// 重写 replace（同上）
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) return err;
    return Promise.reject(err);
  });
};

router.beforeEach((to, from, next) => {
  //  首页 图片 视频  title keywords description
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // console.log('beforeEach')
  // console.log(to)
  // console.log(from)

  // 动态更新meta标签
  let keywordsTag = document.querySelector('meta[name="keywords"]');
  let descriptionTag = document.querySelector('meta[name="description"]');
  if (to.meta.keywords && keywordsTag) {
    keywordsTag.setAttribute("content", to.meta.keywords);
  }
  if (to.meta.description && descriptionTag) {
    descriptionTag.setAttribute("content", to.meta.description);
  }
  //  首页 图片 视频  title keywords description

  next();
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    // alert('重新加载')
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    location.reload();
    // const targetPath = $router.history.pending.fullPath;
    // $router.replace(targetPath);
  }
});

export default router;
